import type { IContentLoaderProps } from 'react-content-loader';

import { SkeletonLoader } from '../SkeletonLoader';

type Props = IContentLoaderProps;

const SkeletonRectangle = ({ width, height, ...props }: Props) => {
  return (
    <SkeletonLoader width={width} height={height} {...props}>
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
    </SkeletonLoader>
  );
};

export default SkeletonRectangle;
